"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "v-inline-dropdown-select-editor",
    props: {
        component: {
            type: Function,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        currentOption: {
            type: Object,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true
        }
    },
    beforeMount: function () {
        this.$options.components.component = this.component;
    },
    data: function () {
        return {
            state: "value"
        };
    },
    methods: {
        switchState: function () {
            if (this.canEdit) {
                this.state = (this.state === "value") ? "component" : "value";
            }
        },
        onChange: function (option) {
            this.switchState();
            this.$emit("update", option);
        }
    }
});
